// ============================================================================
// skylineViewOptions.js — the Skyline view-option id sets, as a LEAF
// ----------------------------------------------------------------------------
// Two frozen id arrays and one default id, each read by two owners that cannot
// import each other's home without closing a module cycle:
//
//   - `DAY_PHASE_MODE_IDS` — the Sky control's vocabulary. `unifiedRouter.js`
//     validates the `workspace.dayPhaseMode` URL slot against it;
//     `workspaceLayout.js` owns the `dayPhaseMode` ref, `setDayPhaseMode`'s
//     whitelist, and the `dayPhaseOptions` rows the Skyline sky control in
//     My Account > Workspace > Appearance renders.
//   - `METADATA_LANES_DISPLAY_IDS` — the Metadata lanes picker's vocabulary.
//     `unifiedRouter.js` validates the `propertyVisualization.metadataLanesDisplay`
//     URL slot against it; `LayerTab.vue` builds its `Metadata lanes` picker
//     rows from it.
//   - `DEFAULT_SKYLINE_LAYER_ID` — the Skyline's default layer.
//     `propertyVisualizationLayerStyling.js` starts its selection on it and
//     falls back to it; `unifiedRouter.js` defaults the
//     `analyze.visualizationLayer` URL slot to it, so a decode of a link that
//     names no layer lands on the same layer the store starts on (th-occ9sd).
//     The store imports the router, so the router cannot read the store.
//
// `unifiedRouter.js` imports `useUserStore` (`stores/user.js`), which imports
// `workspaceLayout.js` — so `unifiedRouter → user → workspaceLayout` is
// already a path, and either store defining these ids and the other importing
// them re-closes it as `… → unifiedRouter` (skyline-non-leasable-plates D3/D5
// worked around this by exporting the ids from `unifiedRouter` and reading
// them only from inside `workspaceLayout`'s setup body, never at
// module-evaluation time — safe, but not the honest home). A LEAF module that
// imports nothing sits outside that cycle entirely: every consumer imports
// from here, and the setup-body workaround is no longer needed anywhere it
// applied (th-e7hnl).
// ============================================================================

/** The Skyline sky's persisted id set (`workspace.dayPhaseMode`). */
export const DAY_PHASE_MODE_IDS = Object.freeze(['auto', 'dawn', 'day', 'dusk', 'night'])

/**
 * The Skyline metadata lanes' persisted id set
 * (`propertyVisualization.metadataLanesDisplay`).
 */
export const METADATA_LANES_DISPLAY_IDS = Object.freeze(['both', 'top', 'bottom', 'none'])

/**
 * The Skyline's default layer (`analyze.visualizationLayer.selectedLayer`): the
 * one the workspace's store starts on and the router's default slot names.
 */
export const DEFAULT_SKYLINE_LAYER_ID = 'property_use_types'
